import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ConfirmDialog(props) {
  const handleClose = () => {
    props.onClose(false);
  };

  const label = props.label || "In Progress";

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{label}</DialogTitle>
      <DialogContent>
        <h3 id="alert-dialog-title" style={{ textAlign: "center" }}>
          {props.text}
        </h3>
        <h3
          id="alert-dialog-description"
          style={{ textAlign: "center", marginTop: 25, marginBottom: 45 }}
        >
          {props.text2}
        </h3>
      </DialogContent>
    </Dialog>
  );
}
